// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"20":"157ae3c2","245":"92d523f9","248":"bc456c60","480":"a83e49a8","487":"37a363d9","587":"67f3c155","700":"781a9c28","751":"157ae3c2","868":"9a44fad5"}[chunkId] + ".css";
};